import { Component, OnInit } from '@angular/core';
import { DataService } from '../../services/data.service';
import { Router, NavigationStart } from '@angular/router';
import { Unidad } from '../../../models/unidad';
import { Util } from '../../utils/functions';
import { Subscription } from 'rxjs/internal/Subscription';
import { GeneralService } from 'src/app/services/general.service';
import { isNullOrUndefined } from 'util';
import { NgxSpinnerService } from 'ngx-spinner';

declare let gtag: Function;

@Component({
  selector: 'app-seccion-descubreenjoy',
  templateUrl: './seccion-descubreenjoy.component.html',
  styleUrls: ['./seccion-descubreenjoy.component.scss']
})
export class SeccionDescubreenjoyComponent implements OnInit {

  subscription: Subscription;
  idIdioma = '';

  ttHotel: string;
  tituloHoteles: string;
  tituloByEnjoyCasino: string;
  tituloHotelByEnjoy: string;

  unidades: Unidad[];
  url: string;
  selectedItem: any = {};
  unidadSelected: Unidad;

  constructor(
    private dataService: DataService,
    private generalService: GeneralService,
    private router: Router,
    private spinner: NgxSpinnerService
  ) { }

  ngOnInit() {
    this.spinner.show();
    this.dataService.currentUrl.subscribe(url => this.url = url);
    this.subscription = this.dataService.$idioma.subscribe(value => {
      this.idIdioma = value;
      switch (this.idIdioma) {
        case 'es': {
          this.traducir('HOTEL', 'HOTELES', 'BY ENJOY Y CASINO', 'HOTEL BY ENJOY');
          break;
        }
        case 'en': {
          this.traducir('HOTEL', 'HOTELS', 'BY ENJOY AND CASINO', 'HOTEL BY ENJOY');
          break;
        }
        case 'port': {
          this.traducir('HOTEL', 'HOTÉIS', 'BY ENJOY E CASINO', 'HOTEL BY ENJOY');
          break;
        }
        default:
            this.traducir('HOTEL', 'HOTELES', 'BY ENJOY Y CASINO', 'HOTEL BY ENJOY');
          break;
      }
      this.dataService.currentUnidades.subscribe(unidades => {
        this.unidades = unidades;
        this.selectedItem = this.unidades.find(unidad => unidad.esHotel);
        setTimeout(()=> {
          this.spinner.hide();
        },2000);
      });
    });

  }

  traducir(tt: string, titulo1: string, titulo2: string, titulo3: string) {
    this.ttHotel = tt;
    this.tituloHoteles = titulo1;
    this.tituloByEnjoyCasino = titulo2;
    this.tituloHotelByEnjoy = titulo3;
  }

  showUnidad(item) {
    //gtag('event', 'Click: Home Unidades', { 'event_category': 'Sección: Descubre Enjoy', 'event_label': item.nombre , 'value' : '0' });
    this.selectedItem = item;
  }
  
  updateImage(key){

    switch (key) {
      case 1:
        //gtag('event', 'Click: Descubre Enjoy', { 'event_category': 'Sección: Descubre Enjoy', 'event_label': 'Enjoy', 'value' : '0' });
        this.selectedItem = this.unidades.find(unidad => unidad.esHotel);
        break;
      case 2:
        //gtag('event', 'Click: Descubre Enjoy', { 'event_category': 'Sección: Descubre Enjoy', 'event_label': 'Enjoy Casino', 'value' : '0' });
        this.selectedItem = this.unidades.find(unidad => unidad.esCasinoByEnjoy);
        break;
      case 3:
        //gtag('event', 'Click: Descubre Enjoy', { 'event_category': 'Sección: Descubre Enjoy', 'event_label': 'Hotel By Enjoy', 'value' : '0' });
        this.selectedItem = this.unidades.find(unidad => unidad.esHotelByEnjoy);
        break;
      default:
        break;
    }
  }

  goUnidad(item) {
    this.dataService.changeUnidadSelected(item);
    this.router.navigate([`/${item.nombre.replace(/[' ']+/g, '-').toLowerCase()}`]);
  }

  isSelectedItem(item) {
    return isNullOrUndefined(this.selectedItem) ? false : this.selectedItem.idUnidad === item.idUnidad;
  }
}
